var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../enums/accordion.js";
import "../../enums/alert.js";
import "../../enums/avatar.js";
import "../../enums/breakpoints.js";
import "../../enums/button.js";
import "../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../enums/colors.js";
import "../../enums/combobox.js";
import "../../enums/date.js";
import "../../enums/drag-and-drop.js";
import "../../enums/dialog.js";
import "../../enums/divider.js";
import "../../enums/dropdown.js";
import "../../enums/fieldset.js";
import "../../enums/font-icon.js";
import { FontAlignments, FontColors, FontDecorations, FontWeights, FontSizes, FontTransforms } from "../../enums/fonts.js";
import "../../enums/headings.js";
import "../../enums/input.js";
import "../../enums/keys.js";
import "../../enums/list.js";
import "../../enums/listbox.js";
import "../../enums/loader.js";
import "../../enums/margin.js";
import "../../enums/option.js";
import "../../enums/pill.js";
import "../../enums/placements.js";
import "../../enums/popout.js";
import "../../enums/privacy.js";
import "../../enums/radio-group.js";
import "../../enums/status.js";
import "../../enums/switch.js";
import "../../enums/table.js";
import "../../enums/tooltip.js";
import "../../enums/transitions.js";
import "../../enums/widths.js";
import "../../themes/alert.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyMediumItalic, fontFamilyMedium, fontWeightMedium, fontFamilyBookItalic, fontFamilyBook, fontWeightBook, fontFamilyBold, fontWeightBold, fontSizeXxSmall, fontSizeXxLarge, fontSizeXSmall, fontSizeXLarge, fontSizeMedium, fontSizeSmall, fontSizeLarge } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
var getFontAlignment = function getFontAlignment(options) {
  var align = options.align;
  switch (align) {
    case FontAlignments.Center:
      {
        return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        text-align: center;\n      "])));
      }
    case FontAlignments.Right:
      {
        // prefer `text-align: end` over `text-align: right` for RTL support
        return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        text-align: end;\n      "])));
      }
    // FontAlignments.Left
    default:
      {
        // prefer `text-align: start` over `text-align: left` for RTL support
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        text-align: start;\n      "])));
      }
  }
};
var getFontColor = function getFontColor(options) {
  var color = options.color,
    darkMode = options.darkMode;
  switch (color) {
    case FontColors.Primary:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), BrandfolderHexColors.PurplePopsicle);
      }
    case FontColors.Warning:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), BrandfolderHexColors.WarningRed);
      }
    // FontColors.Default
    default:
      {
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), darkMode ? BrandfolderHexColors.White : BrandfolderHexColors.Text);
      }
  }
};
var getFontDecoration = function getFontDecoration(options) {
  var decoration = options.decoration;
  switch (decoration) {
    case FontDecorations.Dotted:
      {
        return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        text-decoration: dotted underline;\n      "])));
      }
    case FontDecorations.Underline:
      {
        return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        text-decoration: underline;\n      "])));
      }
    default:
      {
        return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""])));
      }
  }
};
var getFontWeight = function getFontWeight(options) {
  var italic = options.italic,
    weight = options.weight;
  var fontStyle = italic ? css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        font-style: italic;\n      "]))) : css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral([""])));
  switch (weight) {
    case FontWeights.Bold:
      {
        return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-weight: ", ";\n      "])), fontFamilyBold, fontWeightBold);
      }
    case FontWeights.Book:
      {
        return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        ", "\n        font-weight: ", ";\n      "])), italic ? fontFamilyBookItalic : fontFamilyBook, fontStyle, fontWeightBook);
      }
    case FontWeights.Medium:
      {
        return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        ", "\n        font-weight: ", ";\n      "])), italic ? fontFamilyMediumItalic : fontFamilyMedium, fontStyle, fontWeightMedium);
      }
    default:
      {
        return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""])));
      }
  }
};
var getFontSize = function getFontSize(options) {
  var size = options.size;
  switch (size) {
    case FontSizes.Large:
      {
        return css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 28px;\n      "])), fontSizeLarge);
      }
    case FontSizes.Small:
      {
        return css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 22px;\n      "])), fontSizeSmall);
      }
    case FontSizes.Medium:
      {
        return css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 24px;\n      "])), fontSizeMedium);
      }
    case FontSizes.XLarge:
      {
        return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 40px;\n      "])), fontSizeXLarge);
      }
    case FontSizes.XSmall:
      {
        return css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 20px;\n      "])), fontSizeXSmall);
      }
    case FontSizes.XxLarge:
      {
        return css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 50px;\n      "])), fontSizeXxLarge);
      }
    case FontSizes.XxSmall:
      {
        return css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n        font-size: ", "px;\n        line-height: 18px;\n      "])), fontSizeXxSmall);
      }
    default:
      {
        return css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral([""])));
      }
  }
};
var getFontTransform = function getFontTransform(options) {
  var transform = options.transform;
  switch (transform) {
    case FontTransforms.Capitalize:
      {
        return css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n        text-transform: capitalize;\n      "])));
      }
    case FontTransforms.Lowercase:
      {
        return css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n        text-transform: lowercase;\n      "])));
      }
    case FontTransforms.Uppercase:
      {
        return css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n        text-transform: uppercase;\n      "])));
      }
    default:
      {
        return css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral([""])));
      }
  }
};
export { getFontAlignment, getFontColor, getFontDecoration, getFontSize, getFontTransform, getFontWeight };